import { useContext } from 'react';

import { MessageContext } from '@/helpers/MessageProvider';
import useTelemetryData from '@/hooks/useTelemetryData';

const useParamCommand = () => {
  const { publishCommand } = useContext(MessageContext);
  const { getAddress } = useTelemetryData();

  const list = (robot) => {
    const address = getAddress(robot.id);
    publishCommand(robot, 'param/list', [[...address]]);
  };

  const read = (robot, paramGroup) => {
    publishCommand(robot, 'param/read', [paramGroup]);
  };

  const set = (paramId, value, type) => (robot) => {
    const address = getAddress(robot.id);
    const execute = () => publishCommand(robot, 'param/set', [[...address, paramId, value, type]]);

    return {
      execute,
      topic: `${robot.id}/telemetry/paramValue`,
      isMatch: (data) => data.paramId === paramId,
      isSuccess: (data) => {
        // 9: 32-bit floating-point
        if (type === 9) {
          // JavaScript 부동소수점 연산 오차 방지 위한 4자리 제한
          return Number(data.paramValue.toFixed(4)) === value;
        } else {
          return data.paramValue === value;
        }
      },
    };
  };

  return { list, read, set };
};

export default useParamCommand;
